import React, {Component} from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import { Routes, Route} from "react-router-dom";
import './App.css';

import { Checkout } from './routes/checkout/checkout.page';
import { MyAccount } from './routes/my-account/my-account.page';
import { Popups } from './popups/popups';
import { Subscribe } from './routes/subscribe/subscribe.page';
import { SubscribePlans } from './routes/subscribe-plans/subscribe-plans.page';
import NotFound from './components/not-found/not-found.component';

//Cancellation
import { CancelProvider } from './contexts/cancellation.context';
import Cancellation from './routes/cancellation/cancellation.page';
import CancelMain from './routes/cancellation/cancel-main/cancel-main.page';
import Reason from './routes/cancellation/reason/reason.page';
import Keep from './routes/cancellation/keep/keep.page';
import Canceled from './routes/cancellation/canceled/canceled.page';
import Pause from './routes/cancellation/pause/pause.page';
import Paused from './routes/cancellation/pause/paused/paused.page';
import PauseMain from './routes/cancellation/pause/pause-main/pause-main.page';
import Offer from './routes/cancellation/offer/offer.page';
import Customize from './routes/cancellation/customize/customize.page';
import CustomizeMain from './routes/cancellation/customize/customize-main/customize-main.page';
import CustomizeConfirmed from './routes/cancellation/customize/confirmed/confirmed.page';
import OfferMain from './routes/cancellation/offer/offer-main/offer-main.page';
import OfferConfirmed from './routes/cancellation/offer/confirmed/confirmed.page';
import { facebookEvent, getCookie } from './utils/generaFunctions';


class App extends Component {
  constructor(){
    super();
    this.state = {
      page: window.location.pathname.split("/")[1],
      sub: "main",
      title: "",
      back: "",
      description: "",
      choice_title: "",
      button_text:"",
      main_button_text:"",
      main_button_sub:"",
      main_button_path:"",
      main_button_below:"",
      keep: "on",
      calendar: "",
      choice: "on",
      radio: "",
      max_width:"",
      pages: [],
    };   
    const urlParams = new URLSearchParams(window.location.search);
    const promoSession = window.sessionStorage.getItem("promo") || getCookie("promo") || urlParams.get("promo");
    const bonusSession = window.sessionStorage.getItem("bonus") || getCookie("bonus") || urlParams.get("bonus");
    const giftSession = window.sessionStorage.getItem("gift") || getCookie("gift") || urlParams.get("gift");
    if(promoSession === "mtm15off") window.sessionStorage.setItem("promo","mtm25off");
    if(window.location.pathname.includes("subscribe")
      && !window.location.pathname.includes("subscribe-plans")){
        let data = {
          price: 5,
          url: window.location.href};
          facebookEvent("fb_add_to_cart", data);         
        
        // Set promo based on session or default to 25% off
        if(!urlParams.has("promo") && urlParams.get("promo")!=="none" && promoSession && promoSession!=="none") urlParams.set("promo", promoSession);
        if(!urlParams.has("bonus") && bonusSession) urlParams.set("bonus", bonusSession);
        else if(!urlParams.has("bonus") && promoSession && promoSession!=="none" && !bonusSession) urlParams.set("bonus", "namechange");
        if(giftSession) urlParams.set("gift", "yes");
        window.history.pushState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
    }
  }

  handlePageChange = (_sub, _page=this.state.page) => (e) => {
    const newState = this.state.pages.filter(page => (page.page === _page && page.sub === _sub))[0];
    this.setState(newState);
    this.setState({page:_page, sub:_sub});
  }

  render() {
    return(
        <div className="App">
        <div id="custom-popup" className="modal">    
          <div id="modal-content-container">
            <img id="modal-content" alt="modal-content"/>      
          </div>  
        </div>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
          <Routes>
            <Route path="/subscribe/*" element={<Subscribe/>}></Route>
            <Route path="/subscribe-gift-themed/*" element={<Subscribe gift={true}/>}></Route>
            <Route path="/subscribe-plans/*" element={<SubscribePlans/>}></Route>
            <Route path="/my-account/*" element={<MyAccount/>}></Route>
            <Route path="/wedding-planning-essentials/*" element={<MyAccount page="Wedding Planning Essentials"/>}></Route>
            <Route path="/checkout/*" element={<GoogleReCaptchaProvider
              reCaptchaKey="6Ld0eagbAAAAAIk2WXayOcbZBTflQ4Z6DdTbcAUV"
              scriptProps={{
                async: false, // optional, default to false,
                defer: false, // optional, default to false
                appendTo: 'head', // optional, default to "head", can be "head" or "body",
                nonce: undefined // optional, default undefined
              }}
            ><RecurlyProvider 
              publicKey={window.location.href.includes("misstomrsbox.com")?"ewr1-UOuCoHJCcOF92pDf26zeQ7":"ewr1-UOuCoHJCcOF92pDf26zeQ7"/*"ewr1-igZYtRBC4MZV8EhNaOVRCv"*/} 
              required={['cvv']} 
              currency={window.location.href.includes("misstomrsbox.com")?"USD":"USD"}><Elements><Checkout /></Elements></RecurlyProvider></GoogleReCaptchaProvider>}></Route>
              <Route path="/cancellation/*" element={<CancelProvider><Cancellation/></CancelProvider>}>
              <Route index element={<CancelMain/>}></Route>
              <Route path="canceled" element={<Canceled/>}></Route>
              <Route path="customize" element={<Customize/>}>
                <Route index element={<CustomizeMain/>}></Route>
                <Route path="confirmed" element={<CustomizeConfirmed/>}></Route>
              </Route>
              <Route path="keep" element={<Keep/>}></Route>
              <Route path="offer" element={<Offer/>}>
                <Route index element={<OfferMain/>}></Route>
                <Route path="confirmed" element={<OfferConfirmed/>}></Route>
              </Route>
              <Route path="pause" element={<Pause/>}>
                <Route index element={<PauseMain/>}></Route>
                <Route path="paused" element={<Paused/>}></Route>
              </Route>
              <Route path="reason" element={<Reason/>}></Route>
            </Route>
            <Route path="*" element={<NotFound/>}></Route>
          </Routes>
          <Popups></Popups>
      </div>
    )
};

}

export default App;
